import React, { useContext } from 'react';
import './ThreadList.css';
import ThreadListItem from '../ThreadListItem/ThreadListItem';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function ThreadList({ onSelect, threads, fullWidth, selectedThread }) {
  const environmentContext = useContext(EnvironmentContext);
  const { activeUser: user, selectedMonitoredIndividual } = environmentContext;

  if (logComponent('ThreadList')) { console.debug('ThreadList rendered'); }

  const updateSelectedThread = (thread) => {
    if (logComponent('ThreadList')) { console.debug('ThreadList updateSelectedThread'); }
    onSelect(thread);
  }

  return (
    <div className={'Thread-List' + (fullWidth ? ' Thread-List--full-width' : '')}>
      {
        threads &&
        (threads.length > 0 ?
          <ul>
            {
              threads &&
              threads
                .filter(thread => {
                  return (
                    user.groupTypeString === 'Facility' ?
                      true :
                      thread.monitoredIndividualId === selectedMonitoredIndividual.monitoredIndividualId);
                })
                .map(thread =>
                  <ThreadListItem
                    key={thread.userMessageThreadId}
                    thread={thread}
                    onClick={updateSelectedThread}
                    selected={selectedThread &&
                      !fullWidth &&
                      selectedThread.userMessageThreadId === thread.userMessageThreadId} />
                )
            }
          </ul> :
          <p className="Thread-List__empty-message">No threads found...</p>
        )
      }
    </div>
  );
}
